import React from 'react';
import Container from '../common/Container';
import Button from '../common/Button';
import { FaGithub, FaLinkedin, FaSpinner } from "react-icons/fa";
import { FaEnvelope, FaUser, FaEdit, FaComment, FaCheckCircle, FaExclamationCircle, FaMapMarkerAlt, FaPhone } from "react-icons/fa";
import useContact from '../../hooks/useContact';
import '../../styles/Contact.css';

const Contact = () => {
    const {
        theme,
        t,
        formData,
        isSubmitting,
        notification,
        handleChange,
        handleSubmit
    } = useContact();

    return (
        <section id="contact" className={`contact ${theme}`}>
            <div className="contact-background"></div>
            <Container>
                <div className="section-header">
                    <h2 className="section-title">{t.title}</h2>
                    <p className="section-subtitle">{t.subtitle}</p>
                </div>

                <div className="contact-container">
                    <div className="contact-info">
                        <div className="contact-card">
                            <div className="contact-icon">
                                <FaEnvelope />
                            </div>
                            <h3>{t.info.email.label}</h3>
                            <p>{t.info.email.value}</p>
                        </div>

                        <div className="contact-card">
                            <div className="contact-icon">
                                <FaMapMarkerAlt />
                            </div>
                            <h3>{t.info.location.label}</h3>
                            <p>{t.info.location.value}</p>
                        </div>

                        <div className="contact-card">
                            <div className="contact-icon">
                                <FaPhone />
                            </div>
                            <h3>{t.info.phone.label}</h3>
                            <p>{t.info.phone.value}</p>
                        </div>

                        <div className="social-links">
                            <a href="https://github.com/ErickTorres6412" target="_blank" rel="noopener noreferrer" className="social-icon">
                                <FaGithub />
                            </a>
                            <a href="https://www.linkedin.com/in/erick7314/" target="_blank" rel="noopener noreferrer" className="social-icon">
                                <FaLinkedin />
                            </a>
                        </div>
                    </div>

                    <div className="contact-form-container">
                        <form className="contact-form" onSubmit={handleSubmit}>
                            <div className="form-group">
                                <div className="input-icon">
                                    <FaUser />
                                </div>
                                <input
                                    type="text"
                                    name="name"
                                    id="name"
                                    placeholder={t.form.name}
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <div className="input-icon">
                                    <FaEnvelope />
                                </div>
                                <input
                                    type="email"
                                    name="email"
                                    id="email"
                                    placeholder={t.form.email}
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <div className="input-icon">
                                    <FaEdit />
                                </div>
                                <input
                                    type="text"
                                    name="subject"
                                    id="subject"
                                    placeholder={t.form.subject}
                                    value={formData.subject}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <div className="input-icon message-icon">
                                    <FaComment />
                                </div>
                                <textarea
                                    name="message"
                                    id="message"
                                    placeholder={t.form.message}
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                ></textarea>
                            </div>

                            <Button
                                type="submit"
                                variant="primary"
                                size="large"
                                disabled={isSubmitting}
                                className="submit-button"
                            >
                                {isSubmitting ? (
                                    <>
                                        <span>{t.form.sending}</span>
                                        <FaSpinner className="spinning-icon" />
                                    </>
                                ) : (
                                    <>
                                        <span>{t.form.submit}</span>
                                        <span className="button-icon">→</span>
                                    </>
                                )}
                            </Button>
                        </form>
                    </div>
                </div>
            </Container>

            {/* Sistema de notificaciones */}
            {notification.show && (
                <div className={`notification ${notification.type}`}>
                    <div className="notification-content">
                        {notification.type === 'success' ? (
                            <FaCheckCircle />
                        ) : (
                            <FaExclamationCircle />
                        )}
                        <span>{notification.message}</span>
                    </div>
                </div>
            )}
        </section>
    );
};

export default Contact;